import {StyleSheet} from 'react-native';

import {neutral600, white} from '/theme/color/on.color';
import {Apple, cyanBlue, denim} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: white,
    alignItems: 'center',
  },
  title: {
    fontSize: 22,
    color: Apple,
    marginBottom: 4,
    paddingTop: 10,
  },
  subtitle: {
    fontSize: 14,
    marginBottom: 12,
  },
  buttonContainer: {
    flexDirection: 'row',
    gap: 20,
  },
  streakButton: {
    backgroundColor: cyanBlue,
    paddingVertical: 10,
    paddingHorizontal: 22,
    borderRadius: 20,
  },
  streakText: {
    color: denim,
    fontSize: 16,
  },
  shareButton: {
    backgroundColor: neutral600,
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  shareText: {
    color: white,
  },
});
